define('sdk/ui',['utils/wrapper', 'utils/dom_ready', 'utils/dom_helper', 'utils/uri_helper', 'dialog', 'rpc'],
  function(__w, domReady, DomHelper, UriHelper, Dialog, RPC){

  var UI = {
    __dialogs: {},
    root: null,
    getRoot: function(){
      if(this.root){
        return this.root;
      }
      var root = document.getElementById('id-root');
      if (!root) {
        root =  document.createElement('div');
        root.id = 'id-root';
        DomHelper.addClass(root, 'id-reset');
        document.body.appendChild(root);
      }
      else {
        DomHelper.addClass(root, 'id-reset');
      }
      this.root = root;
      return this.root;
    },
    createDialog: function(successFn, errorFn){
      var dialog = new Dialog();
      var self = this;
      dialog.successFn = __w(successFn);
      dialog.errorFn = __w(errorFn);
      dialog.subscribe('dialog.closed', dialog.call);
      this.__dialogs[dialog.id] = dialog;
      DomHelper.addEventListener(dialog.mask, 'click', function() {
        self.destroy(dialog.id);
      });

      return dialog;
    },
    getDialog: function(id){
      return this.__dialogs[id];
    },
    /*
      Hides the dialog and dereferences it
    */
    destroy: function(id){
      var dialog = this.getDialog(id);
      dialog.destroy();
      delete this.__dialogs[dialog.id];
    },

    createIframeDialog: function(successCb, errorCb, path, query) {
      var dialog = this.createDialog(successCb, errorCb);
      // checking for IE browsers
      if (document.attachEvent) {
        // some weird things to make IE work

        this.getRoot().appendChild(dialog.elt);

        var html = (
          '<iframe' +
          ' id="' + dialog.id + '"' +
          ' name="' + dialog.id + '"' +
          ' style="border:none;overflowX:hidden;"' +
          ' src="javascript:false;"' +
          '></iframe>'
        );

        dialog.replaceContent(
           '<iframe src="javascript:false"' +
             ' frameborder="0"' +
             ' scrolling="no"' +
             ' style="height:1px; display:none;"></iframe>'
        );

        query._sdk = dialog.id;

        setTimeout(function() {
          dialog.replaceContent(html);
          var q = UriHelper.buildQuery(query);
          dialog.findContent().firstChild.src = UriHelper.appendToUrl(path, q);
        }, 0);
      } else {
        // this works fine on all non-IE browsers
        var iframe = document.createElement('iframe');
        iframe.name = "dialog-frame-" + dialog.id;
        iframe.id = dialog.id;
        iframe.style.border = 'none';
        iframe.style.overflowX = 'hidden';
        query._sdk = dialog.id;
        var q = UriHelper.buildQuery(query);

        this.getRoot().appendChild(dialog.elt);
        iframe.src = UriHelper.appendToUrl(path, q);

        dialog.replaceContent(iframe);
      }

      dialog.subscribe('dialog.resize', function(w, h){
          var frame = document.getElementById(dialog.id);
          var body = document.body, html = document.documentElement;
          var height = Math.max( body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight );
          var maxHeight = height - 20;
          var overflow = h > maxHeight;
          frame.style.overflow = 'hidden';
          frame.width = w + 'px';
          if(overflow){
            frame.height = maxHeight + 'px';
          }
          else{
            frame.height = h + 'px';
          }
      });

      // keep dialog centered on resize
      // and size background mask to avoid scroll bars
      var self = this;
      DomHelper.addEventListener(window, 'resize', function() {
        self.centerDialog(dialog);
      });

      dialog.show();
      return dialog;
    },

    centerDialog: function(dialog) {
      if (dialog.hidden) {
        return;
      }

      var w = window;
      var d = document;
      var e = d.documentElement;
      var g = d.getElementsByTagName('body')[0];
      var width = w.innerWidth || e.clientWidth || g.clientWidth;
      var height = w.innerHeight || e.clientHeight || g.clientHeight;

      this.sizeMask(dialog, width, height);
      this.sizeFrame(dialog, width, height);

      var x = (width - dialog.width()) / 2;
      var y = (height - dialog.height()) / 2;
      dialog.setLeft(x);
      dialog.setTop(y);
    },

    sizeMask: function(dialog, width, height) {
      dialog.mask.style.width = width + 'px';
      dialog.mask.style.height = height + 'px';
    },

    sizeFrame: function(dialog, width, height) {
      var overflowing = dialog.contentHeight > dialog.height();
      dialog.inform('dialog.resize', dialog.contentWidth, dialog.contentHeight, overflowing);
    },
  };

  /*
   When ready create a root id for storing all the iframes
  */
  domReady(function(){
    UI.getRoot();
  });

  /*
    Handle the dialog was closed by the user through RPC
  */
  RPC.events['dialog.close'] = function(object){
    var dialog = UI.getDialog(object.dialog_id);
    dialog.inform('dialog.closed', null);
    UI.destroy(dialog.id);
  };

  return UI;
});

